import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient, PurchaseOrdersState } from '../client';

const PAGE_SIZE = 25;

type UsePurchaseOrdersParams = {
  search: string;
  state: PurchaseOrdersState;
};

export const usePurchaseOrders = ({ search, state }: UsePurchaseOrdersParams) => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const apiClient = createApiClient(getAccessTokenSilently);

  return useInfiniteQuery({
    queryKey: ['purchaseOrders', state, search],
    queryFn: ({ pageParam = 0 }) => {
      return apiClient.getPurchaseOrders({
        page: pageParam,
        size: PAGE_SIZE,
        search,
        state
      });
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.last || lastPage.empty) return undefined;
      return lastPageParam + 1;
    },
    enabled: isAuthenticated && !isLoading
  });
};
